import { FooterComponent } from './footer/footer.component';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Router, NavigationEnd } from '@angular/router';
declare var ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit, OnDestroy {

  constructor(angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     ga('set', 'page', event.urlAfterRedirects);
    //     ga('send', 'pageview');
    //   }
    // });

    angulartics2GoogleAnalytics.startTracking();
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

}
